import CustomElement from "./CustomElement";

export default class ImagesPop extends CustomElement {
	constructor() {
		super();

		this.container = this.querySelector('.images-pop');
		this.data = this.container.dataset;
		this.radius = parseInt(this.data.radius) || 100;
		this.limit = parseInt(this.data.limit) || 5;
		this.parentContainer = this.container.closest(this.data.target);
		this.images = [...this.querySelectorAll('img')];
		this.offsetY = parseInt(this.data.offsetY) || 30;
		let scaleDesktop = parseFloat(this.data.scaleDesktopTo);

		scaleDesktop = !isNaN(scaleDesktop) ? scaleDesktop : 1;
		let scaleMobile = parseFloat(this.data.scaleMobileTo);

		scaleMobile = !isNaN(scaleMobile) ? scaleMobile : 1;

		this.scaleFrom = 0.2;
		let scaleToDesktop = scaleDesktop - this.scaleFrom;
		let scaleToMobile = scaleMobile - this.scaleFrom;
		this.scaleTo = window.Zero.isMobile ? scaleToMobile : scaleToDesktop

		this.init();

	}

	init() {

		//  Duplicate some if not enough images
		if (this.images.length < this.limit) {
			let remainder = this.limit - this.images.length;
			for (let i = 0; i < remainder; i++) {
				const randI = Math.floor(Math.random() * this.images.length);
				const img = this.images[randI].cloneNode();
				this.container.append(img);
				this.images.push(img);
			}
		}
		// part of cicle we ignore to spread on, in Rad
		const occlusion = Math.PI / 1.5; // 120deg in the bottom
		// Distance between each image around the circle
		const distAngle = ((2 * Math.PI) - occlusion) / this.images.length;

		const center = {
			x: this.parentContainer.offsetLeft + (this.parentContainer.clientWidth / 2),
			y: this.parentContainer.offsetTop + (this.parentContainer.clientHeight / 2)
		};
		let angle = (Math.PI - occlusion) + (-2 * occlusion);
		let rotation = (2 * -Math.PI) / this.limit;
		let alt = -(2 * Math.PI - occlusion)
		let rotations;
		let positions;


		switch (this.limit) {
			case 6:
				rotations = [
					40, -40, -60, 60, -40, 20
				]
				positions = [
					{ x: -24, y: -6 },
					{ x: -24, y: -27 },
					{ x: -6, y: -37 },
					{ x: 15, y: -31 },
					{ x: 23, y: -15 },
					{ x: 26, y: -1 }

				]
				break;

			default:
				rotations = [
					-20, -40, 60, 40, 20
				]
				positions = [
					{ x: -40, y: 28 },
					{ x: -41, y: -18 },
					{ x: 10, y: -30 },
					{ x: 40, y: 0 },
					{ x: 40, y: 33 }
				]
				break;
		}


		for (let i = 0; i < this.images.length; i++) {

			this.images[i].style.setProperty('--x', `${positions[i].x}%`);
			this.images[i].style.setProperty('--y', `${positions[i].y}%`);
			this.images[i].style.setProperty('--rotation', `${rotations[i]}deg`);
			// this.images[i].style.setProperty('--scale', `${this.scaleTo + Math.random() * this.scaleFrom}`);

			angle += distAngle;
			rotation += Math.PI / 4.5
		}

	}
}

